export default __webpack_public_path__ + "static/media/pro-elevate-red-banner-2.9950221d.jpg";